import { render, staticRenderFns } from "./UserLeadsEditModal.vue?vue&type=template&id=a2de5460&"
import script from "./UserLeadsEditModal.vue?vue&type=script&lang=js&"
export * from "./UserLeadsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports